import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import { connect } from 'react-redux';
import download from '../../icons/download.svg';
import accessible from '../../icons/accessible.svg';
import { reportDWH } from '../../PersonalAreaInvoicesSlice';
import { IdentificationActionEnum } from '../../Constant';

const AdditionalInvoices = (props) => {


  const onClick = (type, item )=>{
    const guid = item.invoiceId;
    props.handleOnClickButtonBar(type, guid, item.systemSourcePDF);
    props.reportDWH({ actionType: 'Invoice Page', status: 'Completed', messageText: type  === 'DISPLAY_TAX INVOICE' ?  'Invoice PDF Download' : 'Accessibility PDF Download' });
  };


  return (
    <div className='additional-months'>
      {props.historyPdfList?.length > 0 && (
        <div className='wrapper-more-invoices'>
          <div className='title-more-invoices'>חשבוניות נוספות</div>
          {props.historyPdfList?.map((item, i) => (
            <div key={i} className='row-month'>
              <div className='title-buttons'>
                <div className='title-months'>{item.cycleMonthName} {item.cycleYear}</div>
                <div className='wrapper-buttons'>
                  <button onClick={() => onClick(item.tax,item)}><Image alt='icon' src={download} /> חשבונית מס</button>
                  <button onClick={() => onClick(item.accessible,item)}><Image alt='icon' src={accessible} /> חשבונית נגישה</button>
                </div>
              </div>
              <hr className='hr-month'></hr>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    headerDate: state.personalAreaInvoicesPage.invoicesInfo.history,
    historyPdfList: state.personalAreaInvoicesPage.historyPdfList,
  };
};

const mapDispatchToProps = {
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalInvoices);
